import { formatGeneral } from 'cleave-zen';

export function formatPhoneNumber(value: string): string {
  return formatGeneral(value, {
    delimiterLazyShow: true,
    numericOnly: true,
    blocks: [0, 3, 3, 4],
    delimiters: ['(', ') ', '-'],
  });
}
